const features = [
  {
    id: 1,
    icon: 'ri-4k-line',
    title: '超清画质',
    desc: '支持1080P超清画质，智能码率自适应，享受影院级观影体验。无论大屏还是小屏，画面始终清晰锐利。',
  },
  {
    id: 2,
    icon: 'ri-speed-up-line',
    title: '流畅播放',
    desc: '全球CDN加速节点覆盖，智能预加载技术，告别卡顿和缓冲。秒开即播，拖动无延迟。',
  },
  {
    id: 3,
    icon: 'ri-stack-line',
    title: '海量内容',
    desc: '汇集数万部电视剧全集与电影大片，涵盖国产剧、韩剧、美剧、日剧、动漫、综艺等全品类，满足你的所有追剧需求。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">
            平台优势
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            为什么选择棒棒TV
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 md:gap-6 max-w-4xl mx-auto">
          {features.map((feature) => (
            <div
              key={feature.id}
              className="bg-background-50 rounded-xl p-6 md:p-8 text-center group hover:bg-background-50 transition-colors"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-4 flex items-center justify-center rounded-2xl bg-primary-100">
                <i className={`${feature.icon} text-2xl md:text-3xl text-primary-500`}></i>
              </div>
              <h3 className="text-base md:text-lg font-heading text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}